'use strict'

export function productService (http) {
	return {
		// Load all products
		findAll: function () {
			return http.jsonrpc(
				'/rpc/2.0/products',
				'findAll',
				[]
			).then(function (resp) {
				return resp.result
			})
		},
		// Load product by sku
		findBySKU: function (productSKU) {
			return http.jsonrpc(
				'/rpc/2.0/products',
				'findBySKU',
				[ productSKU ]
			).then(function (resp) {
				return resp.result
			})
		},
		// Add new product
		insert: function (data) {
			return http.jsonrpc(
				'/rpc/2.0/products',
				'insert',
				[ data ]
			).then(function (resp) {
				return resp.result
			})
		},
		// save product changes
		update: function (product) {
			return http.jsonrpc(
				'/rpc/2.0/products',
				'update',
				[ product ]
			).then(function (resp) {
				return resp.result
			})
		}
	}
}



// WEBPACK FOOTER //
// ./src/common/e24-services/product-service.js